import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Params } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromFilters from '~app/modules/filters/store';

@Component({
  selector: 'app-search-catalog-actions',
  templateUrl: './catalog-actions.component.html',
  styleUrls: ['./catalog-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogActionsComponent {
  @Input() queryParams: Params;
  @Input() isSticky = false;
  @Input() isDesktop: boolean;
  @Input() isCategoryPage: boolean;
  @Output() filterOpened = new EventEmitter<void>();

  filtersCount$ = this.store.pipe(select(fromFilters.getFiltersCount));

  constructor(private store: Store<fromFilters.State>) {
  }

  onOpenFilters(): void {
    this.filterOpened.emit();
  }
}
